import { render, staticRenderFns } from "./formScript.vue?vue&type=template&id=7c8efdfa&"
import script from "./formScript.vue?vue&type=script&lang=js&"
export * from "./formScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports